"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const errorBoundary_1 = require("components/errorBoundary");
const errorCard_1 = require("components/errorCard");
const renderFallback = ({ clear }) => ((0, jsx_runtime_1.jsx)(errorCard_1.ErrorCard, { onClick: clear }));
const ContentPortal = ({ name, component: Component }) => {
    const [props, setProps] = (0, react_1.useState)(null);
    const [containerId, setContainerId] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        const listener = (event) => {
            if (event.detail.name === name) {
                setProps(event.detail.props);
                setContainerId(event.detail.containerId);
            }
        };
        window.addEventListener('contentadminportal', listener);
        return () => {
            window.removeEventListener('contentadminportal', listener);
        };
    }, [name]);
    const container = document.getElementById(containerId);
    return (props &&
        container &&
        (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(errorBoundary_1.ErrorBoundary, { fallback: renderFallback, children: (0, jsx_runtime_1.jsx)(Component, { ...props }) }), container));
};
exports.default = ContentPortal;
